export default __webpack_public_path__ + "static/media/c002-general2024-example1.10c065bd.jpg";